/* ============================================================
   Quote Thank You — show the range the visitor enquired about.

   Reads ?product= from the URL (set by the quote form's redirect)
   and reveals the matching panel; falls back to the default mix.

   Also pushes a dataLayer event so GTM/GA4 can register the lead
   on this page, alongside whatever conversion the ad platforms
   fire on the URL itself.
   ============================================================ */
(function () {
  'use strict';

  function push(event, payload) {
    window.dataLayer = window.dataLayer || [];
    var data = { event: event };
    for (var k in payload) {
      if (Object.prototype.hasOwnProperty.call(payload, k)) data[k] = payload[k];
    }
    window.dataLayer.push(data);
  }

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (err) {
      return '';
    }
  }

  function init(root) {
    if (!root || root.dataset.qrThanksReady === 'true') return;
    root.dataset.qrThanksReady = 'true';

    var product = param('product');
    var collections = Array.prototype.slice.call(root.querySelectorAll('[data-qr-collection]'));
    var defaultPanel = root.querySelector('[data-qr-default]');
    var placeholder = root.querySelector('[data-qr-placeholder]');
    var productLine = root.querySelector('[data-qr-thanks-product]');

    // Match the option by its label, which the form put in the URL.
    var matched = null;
    if (product) {
      matched = collections.filter(function (el) {
        return (el.dataset.qrLabel || '') === product;
      })[0];
    }

    if (matched) {
      collections.forEach(function (el) {
        el.hidden = el !== matched;
      });
      if (defaultPanel) defaultPanel.hidden = true;
    } else {
      collections.forEach(function (el) {
        el.hidden = true;
      });
      if (defaultPanel) defaultPanel.hidden = false;
    }

    if (placeholder) placeholder.hidden = !!(matched || defaultPanel);

    // "Your enquiry: Cups" — only when we actually know the product.
    // Token is [product], not Liquid braces: Shopify treats {{ }} in a setting
    // value as a dynamic source and refuses to save the template.
    if (productLine && product) {
      productLine.textContent = productLine.textContent.replace('[product]', product);
      productLine.hidden = false;
    }

    var heading = root.querySelector('h1');
    if (heading) heading.focus({ preventScroll: true });

    push('qr_lead_submitted', { qr_product: product });
  }

  function initAll() {
    document.querySelectorAll('[data-qr-thanks-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-qr-thanks-root]');
    if (root) init(root);
  });
})();
